<template>
    <div>
        <container :plate="'投资军团'" :active_path="'/invest/survey'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="问卷标题">
                            <el-select v-model="form.title" placeholder="请选择问卷调查标题" clearable filterable allow-create default-first-option>
                                <el-option v-for="(item,index) in titles"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm" icon="el-icon-search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success" @click="seereport" icon="el-icon-document">查看报告</el-button>
                        </el-form-item>
                    </el-form>

                </div>
                <div class="table-box">
                    <el-table :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="title" label="问卷标题" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="用户姓名" width="200" ></el-table-column>
                        <el-table-column prop="telephone" label="用户手机" width="200" align="center"></el-table-column>
                        <el-table-column prop="addDate" label="参与时间" width="140" align="center"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <el-button-group slot-scope="s">
                                <el-button type="warning" size="mini" icon="el-icon-tickets" @click="todetail(s.row)"></el-button>
                                <el-button type="success" size="mini" icon="el-icon-document" @click="seereport(s.row)"></el-button>
                            </el-button-group>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue'
export default {
    components: { 
        container,
    },
    data() {
        return {
            form: {
                title: '武汉公寓市场困境与破局调查问卷',
            },
            titles: [
                {name: '武汉公寓市场困境与破局调查问卷'},
            ],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            tabledata: [],
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        todetail(item) {
            var id = item._id['$oid']
            this.$router.push({path: '/invest/survey/detail', query:{id}})
        },
        seereport(item) {
            var title = '';
            title = this.form.title;
            if (item.title) title = item.title;
            this.$router.push({path: '/invest/survey/report', query:{title}})
        },
        confirm() {
            this.pageNo = 1;
            tis.gettabledata();
        },
        gettabledata() {
            var params = {
                title: this.form.title,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getsurveylist(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>